
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/[[...path]]",
      function () {
        return require("private-next-pages/business/[[...path]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/[[...path]]"])
      });
    }
  